module.exports = __webpack_public_path__ + "img/fillgoodslogo.155f64f1.png";